let fetchWithAuth = (method, url, body = false) => {
  let options = {
    method: method,
    headers: {
      Authorization: "Bearer " + window.localStorage.getItem("id_token"),
    },
  };
  if (body) {
    options["body"] = JSON.stringify(body);
  }
  return fetch(`${process.env.REACT_APP_API_URL}${url}`, options)
    .then((response) => {
      if (response.status === 204) {
        return;
      }
      if (response.ok) {
        return response.json();
      }
      if (response.status === 401) {
        return response.json().then((e) => {
          console.log(e);
          throw new Error(e.error);
        });
      }
      throw new Error("Network response failed.");
    })
    .catch(_errorHandler);
};

let fetchVolunteers = () => fetchWithAuth("GET", "/volunteers");

let fetchVolunteer = (id) => fetchWithAuth("GET", `/volunteers/${id}`);

let fetchArchives = () => fetchWithAuth("GET", "/archives");

let fetchAlbums = () => fetchWithAuth("GET", "/albums");

let fetchAlbum = (id) => fetchWithAuth("GET", `/albums/${id}`);

let fetchArtists = () => fetchWithAuth("GET", "/artists");

let fetchArtist = (id) => fetchWithAuth("GET", `/artists/${id}`);

let fetchLabels = () => fetchWithAuth("GET", "/labels");

let fetchLabel = (id) => fetchWithAuth("GET", `/labels/${id}`);

let fetchGenres = () => fetchWithAuth("GET", "/genres");

let fetchGenre = (id) => fetchWithAuth("GET", `/genres/${id}`);

let fetchPrograms = (params) => {
  let url = "/programs";
  if (params.length !== 0) {
    url += `?${params.join("&")}`;
  }
  return fetchWithAuth("GET", url);
};

let fetchSurveyWhereOption = () => fetchWithAuth("GET", `/surveywhere`);

let fetchSurveyWhenOption = () => fetchWithAuth("GET", `/surveywhen`);

let fetchReport = (start,end) => fetchWithAuth("GET", `/report?start_date=${start}&end_date=${end}`);

let fetchSurveyWhere = (id) => fetchWithAuth("GET", `/surveywhere/${id}`);

let fetchSurveyWhen = (id) => fetchWithAuth("GET", `/surveywhen/${id}`);

let postSurveyWhere = (id,data) =>  fetchWithAuth("POST", `/surveywhere/${id}`,data);

let postSurveyWhen = (id,data) =>  fetchWithAuth("POST", `/surveywhen/${id}`,data);

let postSurveyWhereOption = (data) =>  fetchWithAuth("POST", `/surveywhere`,data);

let postSurveyWhenOption = (data) =>  fetchWithAuth("POST", `/surveywhen`,data);

let deleteSurveyWhen =(id)=> fetchWithAuth("DELETE", `/surveywhen/${id}`);

let deleteSurveyWhere =(id)=> fetchWithAuth("DELETE", `/surveywhere/${id}`);

let fetchSurveys = () => fetchWithAuth("GET", `/survey`);

let fetchSurvey = (id) => fetchWithAuth("GET", `/survey/${id}`);

let putSurvey = (id,survey) => fetchWithAuth("PUT", `/survey`, survey);

let deleteSurvey  = (id) => fetchWithAuth("DELETE", `/survey/${id}`);

let postSurvey= (survey) => fetchWithAuth("POST", `/survey`, survey);

let fetchProgram = (id) => fetchWithAuth("GET", `/programs/${id}`);

let fetchPsas = () => fetchWithAuth("GET", `/psa`);

let fetchPsa = (id) => fetchWithAuth("GET", `/psa/${id}`);

let putPsa = (id,psa) => fetchWithAuth("PUT", `/psa/${id}`, psa);

let deletePsa  = (id) => fetchWithAuth("DELETE", `/psa/${id}`);

let postPsa = (psa) => fetchWithAuth("POST", `/psa`, psa);

let fetchNowPlaying = () => fetchWithAuth("POST", "/nowplaying");

let putVolunteer = (volunteer) =>
  fetchWithAuth("PUT", `/volunteers`, volunteer);

let putAlbum = (album) => fetchWithAuth("PUT", `/albums`, album);

let putProgram =(id,program) => fetchWithAuth("PUT",`/programs/${id}`,program)

let postProgram =(program) => fetchWithAuth('POST','/programs',program);

let postVolunteer = (volunteer) =>
  fetchWithAuth("POST", `/volunteers`, volunteer);

let postAlbum = (album) => fetchWithAuth("POST", `/albums`, album);

let postArtist = (item) => fetchWithAuth("POST", `/artists`, item);

let postLabel = (item) => fetchWithAuth("POST", `/labels`, item);

let postGenre = (item) => fetchWithAuth("POST", `/genres`, item);

let postNowPlaying = (item) => fetchWithAuth("POST", `/nowplaying`, item);

let deleteVolunteer = (id) => fetchWithAuth("DELETE", `/volunteers/${id}`);

let deleteProgram = (id) => fetchWithAuth("DELETE", `/programs/${id}`);


let deleteAlbum = (id) => fetchWithAuth("DELETE", `/albums/${id}`);

let fetchPlaylists = () => fetchWithAuth("GET", "/playlists");

let fetchPlaylist = (id) => fetchWithAuth("GET", `/playlists/${id}`);

let putPlaylist = (playlist) => fetchWithAuth("PUT", `/playlists`, playlist);

let postPlaylist = (playlist) => fetchWithAuth("POST", `/playlists`, playlist);

let deletePlaylist = (id) => fetchWithAuth("DELETE", `/playlists/${id}`);

let fetchPlaylistTracks = (playlist_id) =>
  fetchWithAuth("GET", `/playlists/${playlist_id}/tracks`);

let putPlaylistTrack = (playlist_id, track) =>
  fetchWithAuth("PUT", `/playlists/${playlist_id}/tracks`, track);

let postPlaylistTrack = (playlist_id, track) =>
  fetchWithAuth("POST", `/playlists/${playlist_id}/tracks`, track);

let deletePlaylistTracks = (playlist_id) =>
  fetchWithAuth("DELETE", `/playlists/${playlist_id}/tracks`);

let fetchStreamGuysMeta = (callback) => {
  fetch(`https://peridot.streamguys1.com:7175/status.xsl`)
    .then((response) => {
      if (response.ok) {
        return response.text();
      }
      console.error(response.error);
      throw new Error("Network response failed. - icecast");
    })
    .then(callback)
    .catch((error) => {
      console.error(
        "There has been a problem with your status fetch operation: ",
        error.message
      );
    });
};

let fetchKugsProgram = (callback) => {
  fetch(`https://as.wwu.edu/kugs/api/programming/`)
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      console.error(response.error);
      throw new Error("Network response failed. - programming");
    })
    .then(callback)
    .catch((error) => {
      console.error(
        "There has been a problem with your programming fetch operation: ",
        error.message
      );
    });
};

let getSpotifyToken = () => {
  let username = "f040c5f0e1804aebb9e8c4241e742d61";
  let password = "88f06383862844b9b9ee80a09c6ab685";
  return fetch(`https://accounts.spotify.com/api/token`, {
    method: "POST",
    headers: {
      Authorization: "Basic " + window.btoa(username + ":" + password),
    },
    body: new URLSearchParams({
      grant_type: "client_credentials",
    }),
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      console.log(response);
      throw new Error("Network response failed.");
    })
    .catch((e) => {
      console.log(e);
    });
};

let searchSpotify = (query, type) => {
  // todo: automatically provision fresh token if there isn't one valid in local storage
  let url = `/search?q=${query}&type=${type}&include_external=audio`;
  return fetch(`${spotifyURL}${url}`, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + window.localStorage.getItem("spotify_token"),
    },
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      console.log(response);
      throw new Error("Network response failed.");
    })
    .catch((e) => {
      console.log(e);
    });
};
let searchSpotifyByID = (id) => {
  // todo: automatically provision fresh token if there isn't one valid in local storage
  let url = `/albums/${id}
  `;
  return fetch(`${spotifyURL}${url}`, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + window.localStorage.getItem("spotify_token"),
    },
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      console.log(response);
      throw new Error("Network response failed.");
    })
    .catch((e) => {
      console.log(e);
    });
};


let _errorHandler = (error) => {
  console.error("Fetch error: ", error.message);
  alert("Video killed the radio star ... or maybe it was this error ~(x.x)~");
  // window.localStorage.clear();
  window.location.href = "/";
};

const spotifyURL = `https://api.spotify.com/v1`;

export {
  fetchVolunteers,
  fetchVolunteer,
  fetchArchives,
  fetchAlbums,
  fetchAlbum,
  fetchArtists,
  fetchArtist,
  fetchLabels,
  fetchLabel,
  fetchGenres,
  fetchGenre,
  fetchPrograms,
  fetchProgram,
  fetchNowPlaying,
  fetchPlaylists,
  fetchPlaylist,
  fetchPlaylistTracks,
  fetchPsa,
  fetchPsas,
  putPsa,
  postPsa,
  putVolunteer,
  putAlbum,
  putPlaylist,
  putPlaylistTrack,
  putProgram,
  postVolunteer,
  postAlbum,
  postArtist,
  postLabel,
  postGenre,
  postNowPlaying,
  postPlaylist,
  postPlaylistTrack,
  postProgram,
  deleteVolunteer,
  deleteAlbum,
  deletePsa,
  deletePlaylist,
  deletePlaylistTracks,
  deleteProgram,
  getSpotifyToken,
  searchSpotify,
  searchSpotifyByID,
  fetchSurveys,
  fetchSurvey,
  putSurvey,
  deleteSurvey,
  postSurvey,
  postSurveyWhen,
  postSurveyWhere,
  fetchSurveyWhen,
  fetchSurveyWhere,
  fetchSurveyWhenOption,
  fetchSurveyWhereOption,
  postSurveyWhereOption,
  postSurveyWhenOption,
  deleteSurveyWhere,
  deleteSurveyWhen,
  fetchReport,
  fetchStreamGuysMeta,
  fetchKugsProgram,
};
